<template>
    <div class="ps-page-body">
        <SeoHead :title="page.title || 'Privacy Policy'" />

        <marketing-page-hero
            eyebrow="Legal"
            :title="page.title"
            :lead="data.updated_at ? `${__('Last updated')} ${data.updated_at}` : ''"
        />

        <section class="ps-page-body__section">
            <div class="container max-w-4xl">
                <div id="printArea" class="rounded-2xl border border-slate-200 bg-white p-6 md:p-8 leading-7 html prose prose-slate max-w-none" v-html="sanitizeHtml(page.content)" />
                <div class="mt-4">
                    <button
                        type="button"
                        class="inline-flex cursor-pointer items-center rounded-xl border border-emerald-600 bg-emerald-600 px-5 py-2.5 text-sm font-semibold text-white transition hover:bg-emerald-700"
                        @click="print('printArea')"
                    >
                        {{ __('Print') }}
                    </button>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
import Layout from '@/Shared/Landing/Layout'
import MarketingPageHero from '@/Shared/Landing/MarketingPageHero'
import SeoHead from '@/Shared/SeoHead'
import sanitizeHtml from 'sanitize-html'

export default {
    layout: Layout,
    components: {
        MarketingPageHero,
        SeoHead,
    },
    props: {
        data: Object,
        title: String,
    },
    data() {
        return {
            page: JSON.parse(this.data.html),
        }
    },
    methods: {
        print(area) {
            const prtHtml = document.getElementById(area).innerHTML
            let stylesHtml = ''
            for (const node of [...document.querySelectorAll('link[rel="stylesheet"], style')]) {
                stylesHtml += node.outerHTML
            }
            const WinPrint = window.open('', '', 'left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0')
            WinPrint.document.write(`<!DOCTYPE html><html><head>${stylesHtml}</head><body>${prtHtml}</body></html>`)
            WinPrint.document.close()
            WinPrint.focus()
            WinPrint.print()
        },
        sanitizeHtml,
    },
}
</script>
